<template>
  <div class="verify-email-page">
    <div class="verify-card">
      <div class="icon-container" v-if="!loading">
        <i v-if="verified" class="el-icon-success success-icon"></i>
        <i v-else class="el-icon-warning error-icon"></i>
      </div>
      
      <div class="loading-spinner" v-if="loading">
        <i class="el-icon-loading"></i>
      </div>
      
      <h2>{{ pageTitle }}</h2>
      <p class="message">{{ message }}</p>
      
      <div class="actions">
        <el-button v-if="verified" type="primary" @click="goToLogin">
          Go to Login
        </el-button>
        <el-button v-else @click="goToHome">
          Back to Home
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'VerifyEmail',
  data() {
    return {
      loading: true,
      verified: false,
      message: 'Verifying your email...'
    }
  },
  computed: {
    pageTitle() {
      if (this.loading) {
        return 'Verifying Email...'
      }
      return this.verified ? 'Email Verified!' : 'Verification Failed'
    }
  },
  async mounted() {
    const token = this.$route.query.token
    
    if (!token) {
      this.loading = false
      this.verified = false
      this.message = 'Invalid verification link. Please check your email for the correct link.'
      return
    }
    
    try {
      const response = await axios.post('/api/user/verify-email', { token })
      
      if (response && response.data && response.data.code === 200) {
        this.verified = true
        this.message = 'Your email has been verified successfully! You can now log in to your account.'
        this.$message.success('Email verified successfully!')
      } else {
        this.verified = false
        this.message = response.data.error || 'Failed to verify email. The link may have expired.'
      }
    } catch (error) {
      console.error('Verification error:', error)
      this.verified = false
      this.message = error.response?.data?.error || 'Failed to verify email. The link may have expired.'
    } finally {
      this.loading = false
    }
  },
  methods: {
    goToLogin() {
      this.$router.push('/')
    },
    goToHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.verify-email-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.verify-card {
  background: white;
  border-radius: 12px;
  padding: 60px 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
  text-align: center;
}

.icon-container {
  margin-bottom: 30px;
}

.success-icon {
  font-size: 80px;
  color: #67C23A;
}

.error-icon {
  font-size: 80px;
  color: #F56C6C;
}

.loading-spinner {
  margin-bottom: 30px;
  font-size: 80px;
  color: #409EFF;
}

h2 {
  font-size: 32px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
}

.message {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 40px;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 15px;
}

@media (max-width: 600px) {
  .verify-card {
    padding: 40px 30px;
  }
  
  h2 {
    font-size: 24px;
  }
}
</style>

